<template>
  <h-frame type="right" v-model:defaultOpen="openState">
    <div class="threeSolidRight">
      <div class="rightOne">
        <x-title> 实有安防设施 </x-title>
        <threerightone
          @click="rightItemClick({ name: '实有安防' })"
        ></threerightone>
      </div>
      <div class="rightTwo">
        <x-title>
          <div class="titleWidth">实有安防力量</div>
        </x-title>
        <div class="titleYellow">实有力量:{{ strengthlistTotal }}</div>
        <div class="power">
          <div
            class="powerItem"
            v-for="(item, index) in strengthlist"
            :key="index"
            @click="rightItemClick({ name: '实有力量' })"
          >
            <div class="powerItemValue">{{ item.value }}</div>
            <div class="powerItemName">{{ item.name }}</div>
          </div>
        </div>
        <div class="titleYellow">实有装备:{{ equipmentlistTotal }}</div>
        <div class="equipment">
          <ul>
            <li
              v-for="item in equipmentlists"
              :key="item.id"
              @click="rightItemClick({ name: '实有装备' })"
            >
              <img src="~@/assets/images/home/yuan.png" alt="" />
              <div class="right">
                <p class="p1">{{ item.value }}</p>
                <p class="p2">{{ item.name }}</p>
              </div>
            </li>
            <!-- <li>
              <img src="~@/assets/images/home/yuan.png" alt="" />
              <div class="right">
                <p class="p1">78</p>
                <p class="p2">警用装备</p>
              </div>
            </li> -->
          </ul>
        </div>
      </div>
      <div class="rightThree">
        <x-title>
          <div class="titleWidth">实有警情事件</div>
        </x-title>
        <threerighttwo
          @click="rightItemClick({ name: '警情事件' })"
        ></threerighttwo>
      </div>
    </div>
  </h-frame>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  inject,
  watchEffect,
  nextTick,
  // watch // watch([()=>data.要监听的属性,...监听多个属性],(newValue,oldValue)=>{})
} from "vue";
// import * as echarts from "echarts";
// import labelLegend from './labelLegend';
import { useRouter } from "vue-router";
import {
  securitylist,
  strengthlist,
  equipmentlist,
} from "@/api/threeSolid/threeSolidHome.js";
import threerightone from "./threerightone";
import threerighttwo from "./threerighttwo";
export default defineComponent({
  name: "",
  components: { threerightone, threerighttwo },
  props: {
    // frame开关状态
    frameStatus: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, context) {
    const data = reactive({
      eventList: [
        {
          name: "噪音扰民",
          type: "矛盾纠纷",
          addrens: "丰盛园社区",
          people: "张三",
        },
        {
          name: "噪音扰民",
          type: "矛盾纠纷",
          addrens: "丰盛园社区",
          people: "张三",
        },
      ],
      powerInfoList: [
        {
          name: "民警",
          value: 25,
        },
        {
          name: "社区干部",
          value: 15,
        },
        {
          name: "楼组长",
          value: 115,
        },
        {
          name: "志愿者",
          value: 15,
        },
        {
          name: "保安",
          value: 105,
        },
        {
          name: "保洁",
          value: 85,
        },
        {
          name: "保绿",
          value: 15,
        },
        {
          name: "其他",
          value: 15,
        },
      ],
      moreFalse: false,
      securitylists: [],
      strengthlist: [],
      equipmentlists: [],
      equipmentlistTotal: 0,
      strengthlistTotal: 0,
      openState: true,
    });
    const refData = toRefs(data);
    const router = useRouter();

    const regionInfo = inject("region");
    watchEffect(() => {
      if (regionInfo.regionList) {
        nextTick(() => {
          securitylistquery();
          strengthlistquery();
          equipmentlistquery();
        });
      }
    });
    watchEffect(() => {
      context.emit("update:frameStatus", data.openState);
    });
    const rightItemClick = (val) => {
      switch (val.name) {
        case "警情事件":
          router.push("eventDispatch");
          break;
        case "实有安防":
          router.push("ActualSecurityFacilities");
          break;
        case "实有力量":
          router.push("realPower");
          break;
        case "实有装备":
          router.push("actualEquipment");
          break;
        default:
          break;
      }
    };
    const moreClick = () => {
      data.moreFalse = !data.moreFalse;
    };
    // 实有安防
    const securitylistquery = async () => {
      const param = {
        regionIds: regionInfo.regionList.toString(),
      };
      const res = await securitylist(param);
      data.securitylists = res.data;
    };
    // 实有力量
    const strengthlistquery = async () => {
      const param = {
        regionIds: regionInfo.regionList.toString(),
      };
      const res = await strengthlist(param);
      data.strengthlist = res.data;
      data.strengthlistTotal = res.data.reduce((p, item) => {
        return p + item.value;
      }, 0);
    };
    // 实有装备
    const equipmentlistquery = async () => {
      const param = {
        regionIds: regionInfo.regionList.toString(),
      };
      const res = await equipmentlist(param);
      data.equipmentlists = res.data;
      data.equipmentlistTotal = res.data.reduce((p, item) => {
        return p + item.value;
      }, 0);
    };
    securitylistquery();
    strengthlistquery();
    equipmentlistquery();

    return {
      ...refData,
      moreClick,
      rightItemClick,
    };
  },
});
</script>
<style lang="scss" scoped>
.dialog {
  position: absolute;
  position: absolute;
  bottom: 200px;
  right: 360px;
  transition: all 0.5s;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-start;
}
.threeSolidRight {
  width: 100%;
  height: 100%;
  padding: 0 10px;
  padding-top: 10px;
  color: #fff;
  overflow: auto;
  .rightOne {
    width: 100%;
    height: 28%;
  }
  .rightTwo {
    width: 100%;
    height: 42%;
    .rightItem {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      width: 100%;
      font-size: 14px;
      .itemList {
        width: 81px;
        height: 72px;
        display: flex;
        flex-direction: column;
        background-image: url("~@/assets/images/home/yujing.png");
        text-align: center;
        margin-bottom: 24px;
        .itenSize {
          margin-top: 18px;
          margin-bottom: 35px;
        }
      }
    }
    .power {
      width: 100%;
      height: 42%;
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .powerItem {
        width: 22%;
        height: 47%;
        background-image: url("~@/assets/images/home/yujing.png");
        background-size: 100% 100%;
        position: relative;
        text-align: center;
        cursor: pointer;
        .powerItemValue {
          position: absolute;
          top: 13%;
          left: 0;
          right: 0;
          font-size: 24px;
          color: #29f0f3;
        }
        .powerItemName {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          font-size: 14px;
        }
      }
    }
  }
  .rightThree {
    width: 100%;
    height: 30%;
  }
  .titleWidth {
    width: 100%;
  }
  .titleMore {
    float: right;
    cursor: pointer;
    margin-right: 15px;
  }
  .titleYellow {
    width: 100%;
    text-align: center;
    color: #f3ce61;
    line-height: 40px;
  }
  .rightItem {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    font-size: 14px;
    .itemList {
      width: 81px;
      height: 72px;
      display: flex;
      flex-direction: column;
      background-image: url("~@/assets/images/home/yujing.png");
      text-align: center;
      margin-bottom: 24px;
      .itenSize {
        margin-top: 18px;
        margin-bottom: 35px;
      }
    }
  }
  .event {
    width: 100%;
    display: flex;
    flex-direction: column;
    // margin-bottom: 15px;
    .eventTop {
      display: flex;
      margin: 15px 0;
      justify-content: space-around;
      .topItem {
        display: flex;
      }
      .topLeft {
        width: 58px;
        height: 57px;
        margin-right: 10px;
        text-align: center;
        line-height: 57px;
        background-image: url("~@/assets/images/home/yuan.png");
        background-size: cover;
      }
      .topRight {
        display: flex;
        flex-direction: column;
        .sizeNum {
          font-size: 20px;
          margin-bottom: 5px;
        }
      }
    }
  }
  .echarts {
    width: 100%;
    height: 180px;
  }

  .blueColor {
    color: #73f1f3;
  }
  .moreSelect {
    position: absolute;
    bottom: 24px;
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    border-radius: 4px;
    line-height: 28px;
    cursor: pointer;
  }
  .downBtn {
    padding: 3px 5px;
    background: rgba(0, 0, 0, 0.5);
    // border-radius: 5px;
    position: absolute;
    width: 100%;
    text-align: center;
    cursor: pointer;
  }

  .equipment {
    ul {
      display: flex;
      justify-content: space-evenly;
      li {
        display: flex;
        align-items: center;
        cursor: pointer;
        img {
          width: 40px;
        }
        .right {
          margin-left: 14px;
          .p1 {
            font-size: 23px;
            color: #29f0f3;
          }
        }
      }
    }
  }
}
</style>
